import axios from "../../axiosInstance";
import type { BadgeAward, BadgeAwardFilters } from "@/modules/learningCenter/features/BadgeManagement/types/badgeAward.types";

export const fetchBadgeAwards = async (filters?: BadgeAwardFilters): Promise<BadgeAward[]> => {
  const params = new URLSearchParams();

  if (filters?.userId) params.append("user_id", filters.userId);
  if (filters?.badgeId) params.append("badge_id", filters.badgeId);

  const response = await axios.get<{ awards: BadgeAward[] }>(`/api/badges/awards?${params.toString()}`);
  return response.data.awards;
};

export default fetchBadgeAwards;
